module.exports = __webpack_public_path__ + "static/img/06_1024.be62dba.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/store_files/images/hoopstack/06_1024.jpg
// module id = yayI
// module chunks = 0